import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';

import { Tooltip } from '@xsolla/ui-core';
import { Checkmark } from '@xsolla/ui-icons';

import { usePaths } from '../../../routes/routesHelper';
import { RouteParams } from '../../../routes/types';
import { getSettingsPageLinks } from './settings';
import { CheckedElement, DangerTitle, ItemTitle, ItemWrapper, UncheckedElement } from './style';

export type ChecklistItemProps = RouteComponentProps & {
  name: string;
  completed?: boolean;
};

const CheckListItem = ({ completed, name, match, history }: ChecklistItemProps): JSX.Element => {
  const paths = usePaths();
  const settingsPageLinks = getSettingsPageLinks(paths);
  const { projectId } = match.params as RouteParams;
  const intl = useIntl();

  const navigateToSetting = () => {
    history.push({
      pathname: settingsPageLinks[name]?.(projectId)
    });
  };

  return (
    <ItemWrapper>
      {completed ? (
        <CheckedElement>
          <Checkmark size={18} />
        </CheckedElement>
      ) : (
        <UncheckedElement />
      )}
      <ItemTitle onClick={navigateToSetting} disabled={!settingsPageLinks[name]}>
        {intl.messages[`check-list.${name}.title`]}
      </ItemTitle>
      {typeof completed === 'undefined' && <DangerTitle>(not)</DangerTitle>}
      <Tooltip
        content={intl.messages[`check-list.${name}.tooltip`]}
        delayEnter={0}
        delayLeave={0}
        offset={0}
        placement="top-center"
      />
    </ItemWrapper>
  );
};

export default withRouter(CheckListItem);
